/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".happ-default-slider[_ngcontent-%COMP%]{display:flex;flex-direction:column}.happ-default-title[_ngcontent-%COMP%]{margin:auto 10px auto auto}  .mat-slider-thumb-label{transform:rotate(45deg)!important;border-radius:50% 50% 0!important;height:20px!important;width:20px!important;margin-top:15px!important}  .mat-slider-thumb{transform:scale(0)!important}  .mat-slider-thumb-label-text{font-size:10px;opacity:1!important}"];
export { styles as styles };
